/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Button as MUIButton,
  Card,
  CardHeader,
  Checkbox,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core'
import React, { FunctionComponent, useState } from 'react'
import {
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdSearch,
} from 'react-icons/md'
import SizedBox from 'shared/components/SizedBox'
import { colors } from 'shared/styles/colors'
import InputText from 'shared/components/InputText'
import { ICnpjFrotista } from '..'

export interface IProps {
  availableCnpjs: any
  setAvailableCnpjs: (value: any) => void
  selectedCnpjs: any
  setSelectedCnpjs: (value: any) => void
  searchAvailableCnpjs: any
  setSearchAvailableCnpjs: (value: any) => void
}

const TransferList: FunctionComponent<IProps> = ({
  availableCnpjs,
  setAvailableCnpjs,
  selectedCnpjs,
  setSelectedCnpjs,
  searchAvailableCnpjs,
  setSearchAvailableCnpjs,
}) => {
  const [checkedItems, setCheckedItems] = useState<ICnpjFrotista[]>([])
  const [searchSelectedCnpjs, setSearchSelectedCnpjs] = useState<
    ICnpjFrotista[]
  >([])

  const removeFromList = (a: ICnpjFrotista[], b: ICnpjFrotista[]) => {
    return a.filter(value => b.indexOf(value) === -1)
  }

  const intersection = (a: ICnpjFrotista[], b: ICnpjFrotista[]) => {
    return a.filter(value => b.indexOf(value) !== -1)
  }

  const union = (a: ICnpjFrotista[], b: ICnpjFrotista[]) => {
    return [...a, ...removeFromList(b, a)]
  }

  const availableCnpjsChecked = intersection(checkedItems, availableCnpjs)
  const selectedCnpjsChecked = intersection(checkedItems, selectedCnpjs)

  const handleToggle = (value: ICnpjFrotista) => () => {
    const currentIndex = checkedItems.indexOf(value)
    const newChecked = [...checkedItems]

    if (currentIndex === -1) {
      newChecked.push(value)
    } else {
      newChecked.splice(currentIndex, 1)
    }

    setCheckedItems(newChecked)
  }

  const numberOfChecked = (items: ICnpjFrotista[]) =>
    intersection(checkedItems, items).length

  const handleToggleAll = (items: ICnpjFrotista[]) => () => {
    if (numberOfChecked(items) === items.length) {
      setCheckedItems(removeFromList(checkedItems, items))
    } else {
      setCheckedItems(union(checkedItems, items))
    }
  }

  const handleCheckedRight = () => {
    setSelectedCnpjs(selectedCnpjs.concat(availableCnpjsChecked))
    setAvailableCnpjs(removeFromList(availableCnpjs, availableCnpjsChecked))
    setCheckedItems(removeFromList(checkedItems, availableCnpjsChecked))

    setSearchAvailableCnpjs(
      removeFromList(searchAvailableCnpjs, availableCnpjsChecked),
    )
    setSearchSelectedCnpjs(selectedCnpjs.concat(availableCnpjsChecked))
  }

  const handleCheckedLeft = () => {
    setAvailableCnpjs(availableCnpjs.concat(selectedCnpjsChecked))
    setSelectedCnpjs(removeFromList(selectedCnpjs, selectedCnpjsChecked))
    setCheckedItems(removeFromList(checkedItems, selectedCnpjsChecked))

    setSearchSelectedCnpjs(
      removeFromList(searchSelectedCnpjs, selectedCnpjsChecked),
    )
    setSearchAvailableCnpjs(availableCnpjs.concat(selectedCnpjsChecked))
  }

  const cardBody = (
    list: ICnpjFrotista[],
    searchList: ICnpjFrotista[],
    setSearchList: any,
  ) => {
    return (
      <Card>
        <CardHeader
          avatar={
            <Checkbox
              style={{ color: colors.green }}
              onClick={handleToggleAll(list)}
              checked={
                numberOfChecked(list) === list.length && list.length !== 0
              }
              indeterminate={
                numberOfChecked(list) !== list.length &&
                numberOfChecked(list) !== 0
              }
              disabled={list.length === 0}
            />
          }
          title="Selecionar tudo"
        />
        <div style={{ margin: '0px 20px 20px 20px' }}>
          <InputText
            onChange={e => {
              setSearchList(
                list.filter(cnpj => cnpj.cnpj.includes(e.target.value)),
              )
            }}
          />

          <div style={{ marginTop: -30, marginLeft: 260 }}>
            <MdSearch />
          </div>
        </div>

        <Divider />

        <List
          dense
          component="div"
          role="list"
          style={{ overflow: 'auto', height: 250, width: 330 }}
        >
          {searchList.map((value: ICnpjFrotista) => {
            const labelId = `transfer-list-all-item-${value.id}-label`

            return (
              <ListItem
                style={{ scrollBehavior: 'auto' }}
                key={value.id}
                role="listitem"
                button
                onClick={handleToggle(value)}
              >
                <ListItemIcon>
                  <Checkbox
                    style={{
                      color: colors.green,
                    }}
                    checked={checkedItems.indexOf(value) !== -1}
                  />
                </ListItemIcon>
                <ListItemText id={labelId} primary={value.cnpj} />
              </ListItem>
            )
          })}
          <ListItem />
        </List>
      </Card>
    )
  }

  return (
    <Grid container spacing={2} justifyContent="flex-start">
      <Grid item>
        {cardBody(
          availableCnpjs,
          searchAvailableCnpjs,
          setSearchAvailableCnpjs,
        )}
      </Grid>

      <Grid item style={{ alignSelf: 'center' }}>
        <Grid container direction="column" alignItems="center">
          <MUIButton
            variant="outlined"
            size="small"
            onClick={handleCheckedRight}
            style={{
              width: 100,
              color: colors.green,
              borderColor: colors.green,
            }}
            disabled={availableCnpjsChecked.length === 0}
          >
            <MdKeyboardArrowRight />
            Inserir
          </MUIButton>

          <SizedBox />

          <MUIButton
            variant="outlined"
            size="small"
            onClick={handleCheckedLeft}
            style={{
              width: 100,
              color: colors.red,
              borderColor: colors.red,
            }}
            disabled={selectedCnpjsChecked.length === 0}
          >
            <MdKeyboardArrowLeft />
            Remover
          </MUIButton>
        </Grid>
      </Grid>

      <Grid item>
        {cardBody(selectedCnpjs, searchSelectedCnpjs, setSearchSelectedCnpjs)}
      </Grid>
    </Grid>
  )
}

export default TransferList
